import { useCallback } from "react";
import { exportData, type ExportOptions } from "~utils/fileTransfer";

/**
 * Hook that returns a function to export data as XLSX or CSV
 */
export function useFileExport(outputName = "export") {
  return useCallback(
    (opts: ExportOptions, type: "xlsx" | "csv") => {
      exportData(opts, type, outputName);
    },
    [outputName]
  );
}
